export const USER_ACTIVITY_EVENT = 'dfl-user-session-started';
export const USER_ACTIVITY_KEY = 'dfl_user_last_activity_at';
export const SESSION_IDLE_TIMEOUT_MS = 10 * 60 * 1000;

export const activateUserSession = () => {
  sessionStorage.setItem(USER_ACTIVITY_KEY, String(Date.now()));
  window.dispatchEvent(new Event(USER_ACTIVITY_EVENT));
};

export const clearUserSessionActivity = () => {
  sessionStorage.removeItem(USER_ACTIVITY_KEY);
};

export const isUserSessionIdle = () => {
  const lastActivity = Number(sessionStorage.getItem(USER_ACTIVITY_KEY));
  return Boolean(lastActivity && Date.now() - lastActivity >= SESSION_IDLE_TIMEOUT_MS);
};